import { apiGet, apiPost, apiPut } from './api';

// Premium Study Modes client. All Premium calls live under the versioned
// Premium namespace (/api/premium/v1/*).
//
// The mode is a SETTLED preference, not a per-session question (owner feedback:
// being asked again on every subject was annoying). It therefore lives in
// localStorage and survives new chats, subject switches and page loads — it
// only ever changes when the student taps the mode button themselves.
// Study Buddy Mode was removed: two choices, not three.

const P = '/premium/v1';
const MODE_KEY = 'gv_study_mode';
const LEGACY_KEY = 'gv_study_mode';   // sessionStorage, pre-sticky-mode builds

export const MODES = { EXPLORE: 'explore', EXAM: 'ai_tutor' };

export function getStoredMode(user) {
  try {
    if (user) {
      const saved = user.study_mode || localStorage.getItem(`${MODE_KEY}_${user.user_id}`);
      if (saved) return saved === 'study_buddy' ? MODES.EXAM : saved;
      if (!user.onboarding_complete || localStorage.getItem('gv_mode_legacy_owner')) return '';
      localStorage.setItem('gv_mode_legacy_owner', user.user_id);
    }
    let mode = localStorage.getItem(MODE_KEY) || '';
    if (!mode) {
      // carry a mid-session choice over from the old sessionStorage build
      mode = sessionStorage.getItem(LEGACY_KEY) || '';
      if (mode) localStorage.setItem(MODE_KEY, mode);
    }
    // anyone who was left in the retired Study Buddy Mode lands in Exam Mode
    if (mode === 'study_buddy') {
      mode = MODES.EXAM;
      localStorage.setItem(MODE_KEY, mode);
    }
    if (mode && user) localStorage.setItem(`${MODE_KEY}_${user.user_id}`, mode);
    return mode;
  } catch { return ''; }
}
export function setStoredMode(mode, user) {
  try {
    const key = user ? `${MODE_KEY}_${user.user_id}` : MODE_KEY;
    if (mode) localStorage.setItem(key, mode);
    else localStorage.removeItem(key);
    sessionStorage.removeItem(LEGACY_KEY);
  } catch { /* noop */ }
}

/**
 * Premium-off contract: when the master/module switch is off the endpoint 404s.
 * Callers get {premium_off: true} and must render the pre-Premium experience.
 */
export async function fetchModes() {
  try {
    const d = await apiGet(`${P}/study/modes`);
    return { premium_off: false, modes: d.modes || [], entitlement_source: d.entitlement_source || '' };
  } catch {
    return { premium_off: true, modes: [], entitlement_source: '' };
  }
}

export const fetchEntitlements = () => apiGet(`${P}/entitlements`);
export const fetchActiveSession = (subject, topic) =>
  apiGet(`${P}/study/sessions/active?subject=${encodeURIComponent(subject || '')}&topic=${encodeURIComponent(topic || '')}`);
export const startGuidedSession = (subject, topic) => apiPost(`${P}/study/sessions`, { subject, topic });
export const fetchExplanation = (sid) => apiPost(`${P}/study/sessions/${sid}/explain`, {});
export const fetchReflection = (sid) => apiPost(`${P}/study/sessions/${sid}/reflect`, {});
export const completeStep = (sid, stepKey) => apiPost(`${P}/study/sessions/${sid}/complete-step`, { step_key: stepKey });

// Admin kill switches (Premium-owned endpoints)
export const fetchPremiumFlags = () => apiGet(`${P}/admin/flags`);
export const savePremiumFlags = (payload) => apiPut(`${P}/admin/flags`, payload);
